import { SPLOOT_BADGE_COLOR } from "../themes";
import type { IGroomingTraining } from "../interfaces";

/**
 * Document verification status (PAN, Bank, KYC documents)
 */
export enum EDocumentVerificationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum EOnboardingTabId {
  TRAINING_GROOMING = "training-grooming",
  DOCUMENT_VERIFICATION = "document-verification",
  KIT_STATUS = "kit-status",
}

/**
 * Enum for KYC document types used in admin tasks
 */
export enum EKycDocumentType {
  AADHAR = "AADHAR",
  PAN = "PAN",
  CHEQUE = "CHEQUE",
  BANK_ACCOUNT = "BANK_ACCOUNT",
}

/**
 * Enum for partner document number field names
 */
export enum EPartnerDocumentNumberField {
  AADHAR_NUMBER = "aadharNumber",
  PAN_NUMBER = "panNumber",
}

/**
 * Enum for partner document image field names
 */
export enum EPartnerDocumentImageField {
  AADHAR_IMAGE_URL = "aadharImageUrl",
  PAN_IMAGE_URL = "panImageUrl",
}

/**
 * Badge colors for document verification statuses
 */
export const DOCUMENT_VERIFICATION_STATUS_BADGE_COLORS = {
  [EDocumentVerificationStatus.PENDING]: SPLOOT_BADGE_COLOR.YELLOW,
  [EDocumentVerificationStatus.APPROVED]: SPLOOT_BADGE_COLOR.GREEN,
  [EDocumentVerificationStatus.REJECTED]: SPLOOT_BADGE_COLOR.RED,
} as const;

/**
 * Grooming onboarding: kit/equipment photo fields shown in partner profile.
 */
type GroomingKitPhotoKey = keyof NonNullable<IGroomingTraining["kitPhotos"]>;

export const GROOMING_KIT_PHOTO_FIELDS: Array<{
  key: GroomingKitPhotoKey;
  label: string;
}> = [
  { key: "dryerPhotoUrl", label: "Dryer" },
  { key: "trimmerPhotoUrl", label: "Trimmer" },
  { key: "scissorsPhotoUrl", label: "Scissors" },
  { key: "shampooPhotoUrl", label: "Shampoo" },
  { key: "kitAdditionalPhotoUrl1", label: "Other" },
  { key: "kitAdditionalPhotoUrl2", label: "Other" },
] as const;
